import { Box, CircularProgress } from "@mui/material";

type IProps = {
  height?: any;
  size?: any;
};

const Loading: React.FC<IProps> = ({ height = "50vh", size = 60 }) => {
  return (
    <Box
      sx={{
        height,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress color="primary" size={size} />
    </Box>
  );
};

export default Loading;
